module.exports = __webpack_public_path__ + "static/media/yellowCheckbox.a48101d1.svg";